






















import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

import ClientsList from '@/components/Broker/ClientsList.vue';

import Policy from '@/services/Policy';

import * as Sentry from '@sentry/browser';
import Welcome from '@/components/Global/Welcome.vue';
@Component({
     name: 'PageClients',
     components: {
          Welcome,
          Loading,
          ClientsList,
          Sidebar,
     },
})
export default class BrokerClients extends Vue {
     private error: boolean;
     private loading: boolean;
     private clientsList: any;

     constructor() {
          super();

          this.error = false;
          this.loading = true;
          this.clientsList = [];
     }

     private async created() {
          try {
               const policies = await Policy.getBrokerPolicies(this.$store.state.Auth.brokerageId);
               this.clientsList = policies.data;
               console.log('policies', this.clientsList);
          } catch (error) {
               Sentry.captureException(error);
               this.error = error;
          } finally {
               this.loading = false;
          }
     }
}
